import { Dot } from '../General';
import { COLOR } from '../shared/shared';
import React from 'react';

// DOT SHOULD LIVE HERE

interface IOStatusProps {
	pColor: COLOR | COLOR[];
	pShadowColor: COLOR | COLOR[];
	pTitle: string;
	pSize?: number;
}

export default function IOStatus({
	pColor,
	pShadowColor,
	pTitle,
	pSize = 30,
}: IOStatusProps) {
	return (
		<div className="flex-row">
			<div className="flex-row align-center full-height">
				{Array.isArray(pColor) &&
					Array.isArray(pShadowColor) &&
					pColor.map((pC, pIdx) => {
						return (
							<Dot
								className="margin-left"
								key={pIdx}
								pSize={pSize}
								pColor={pC}
								pShadowColor={pShadowColor[pIdx]}
							/>
						);
					})}
				{!Array.isArray(pColor) && !Array.isArray(pShadowColor) && (
					<Dot pSize={pSize} pColor={pColor} pShadowColor={pShadowColor} />
				)}
				<span className="font-3 padding-left">{pTitle}</span>
			</div>
		</div>
	);
}

export function IOColumn({ pItems }: { [key: string]: any }) {
	const lKeys = Object.keys(pItems);
	return (
		<section>
			<div>
				{lKeys.length > 0 ? (
					<div className="flex-col">
						{lKeys.map(function (pKey: string, pIndex) {
							const lOn = !!pItems[pKey];
							return (
								<div key={pIndex} className="double-margin-bottom">
									<IOStatus
										pColor={lOn ? COLOR.GREEN : COLOR.DARK_GREY}
										pShadowColor={lOn ? COLOR.TRANSPARENT_GREEN : COLOR.BORDER_GREY}
										pTitle={pKey}
									/>
								</div>
							);
						})}
					</div>
				) : (
					<div></div>
				)}
			</div>
		</section>
	);
}
